// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gp7E","fullView":"styles_fullView__1T_o8"};